import * as React from "react"

const ToastProvider = ({ children }: { children: React.ReactNode }) => <>{children}</>
const ToastViewport = () => null
const Toast = ({ children, variant }: { children: React.ReactNode; variant?: string }) => <>{children}</>
const ToastTitle = ({ children }: { children: React.ReactNode }) => <div>{children}</div>
const ToastDescription = ({ children }: { children: React.ReactNode }) => <div>{children}</div>

export { ToastProvider, ToastViewport, Toast, ToastTitle, ToastDescription }
